import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Plane, LayoutDashboard, FolderOpen, LogOut, MessageSquare, Users, UserCog, Mail } from 'lucide-react';

export default function Layout({ children }) {
  const { admin, logout } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const navItems = [
    { path: '/', label: 'Dashboard', icon: LayoutDashboard },
    { path: '/cases', label: 'Dossiers', icon: FolderOpen },
    { path: '/inbox', label: 'Messagerie', icon: MessageSquare },
    { path: '/referrers', label: 'Apporteurs', icon: Users },
    { path: '/team', label: 'Équipe', icon: UserCog },
  ];

  return (
    <div style={styles.wrap}>
      <header style={styles.header}>
        <div style={styles.headerInner}>
          <Link to="/" style={styles.logo}>
            <div style={styles.logoIcon}><Plane size={18} color="#fff" /></div>
            <span style={styles.logoText}>FlyCash</span>
          </Link>

          <nav style={styles.nav}>
            {navItems.map(({ path, label, icon: Icon }) => (
              <Link
                key={path}
                to={path}
                style={{
                  ...styles.navLink,
                  ...(location.pathname === path || (path === '/cases' && location.pathname.startsWith('/cases'))
                    ? styles.navLinkActive : {})
                }}
              >
                <Icon size={16} />
                {label}
              </Link>
            ))}
          </nav>

          <div style={styles.userArea}>
            <a
              href="https://mail.zoho.eu/zm/#mail/views/all"
              target="_blank"
              rel="noopener noreferrer"
              style={styles.zohoBtn}
              title="Ouvrir Zoho Mail"
            >
              <Mail size={14} color="#fff" />
              <span>Mail</span>
            </a>
            <span style={styles.userName}>{admin?.name || admin?.email}</span>
            <button onClick={handleLogout} style={styles.logoutBtn}>
              <LogOut size={16} />
            </button>
          </div>
        </div>
      </header>
      <main style={styles.main}>{children}</main>
    </div>
  );
}

const styles = {
  wrap: { minHeight: '100vh', background: '#F7F7F8' },
  header: { background: '#0D1B3E', position: 'sticky', top: 0, zIndex: 100 },
  headerInner: {
    maxWidth: 1600, margin: '0 auto', padding: '0 28px', height: 64,
    display: 'flex', alignItems: 'center', justifyContent: 'space-between',
  },
  logo: { display: 'flex', alignItems: 'center', gap: 10, textDecoration: 'none' },
  logoIcon: {
    width: 32, height: 32, borderRadius: 8, background: '#E8920A',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
  },
  logoText: { color: '#fff', fontWeight: 800, fontSize: 18 },
  nav: { display: 'flex', gap: 4 },
  navLink: {
    display: 'flex', alignItems: 'center', gap: 6, padding: '8px 14px',
    borderRadius: 8, color: 'rgba(255,255,255,0.7)', textDecoration: 'none',
    fontSize: 14, fontWeight: 600, transition: 'all 0.2s',
  },
  navLinkActive: { background: 'rgba(232,146,10,0.15)', color: '#E8920A' },
  userArea: { display: 'flex', alignItems: 'center', gap: 12 },
  zohoBtn: { display: 'inline-flex', alignItems: 'center', gap: 5, fontSize: 12, fontWeight: 600, color: '#fff', textDecoration: 'none', padding: '5px 10px', borderRadius: 6, background: 'rgba(255,255,255,0.15)', whiteSpace: 'nowrap' },
  userName: { color: 'rgba(255,255,255,0.7)', fontSize: 13 },
  logoutBtn: {
    background: 'rgba(255,255,255,0.1)', border: 'none', borderRadius: 8,
    padding: 8, color: '#fff', cursor: 'pointer', display: 'flex',
  },
  main: { maxWidth: 1600, margin: '0 auto', padding: '24px 28px' },
};
